/**
 * SizingRendererCPR — CPR view strategy for the sizing display object.
 *
 * Manages a single composite overlay that draws all diameter lines and
 * length arrows on the CPR straightened/stretched view.
 */

import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';

import type { IViewport } from '../../viewports';
import { CprMeasurementsOverlay } from '../overlay-actors/cpr-measurements-overlay';
import type { SizingDisplayData, SizingDisplayProperties } from '../types';
import type { ISizingRenderer } from './sizing-display-object';

export class SizingRendererCPR implements ISizingRenderer {
    private viewport: IViewport | null = null;
    private overlay: CprMeasurementsOverlay | null = null;

    initialize(viewport: IViewport, featureId: string): void {
        this.viewport = viewport;

        this.overlay = new CprMeasurementsOverlay({
            id: `sizing-cpr-measurements-${featureId}`,
        });
        viewport.getOverlayLayer().addOverlayObject(this.overlay);
    }

    update(data: SizingDisplayData, properties: SizingDisplayProperties): void {
        if (!this.overlay) return;
        this.overlay.updateData(data, properties);
    }

    dispose(): void {
        if (this.viewport && this.overlay) {
            this.viewport.getOverlayLayer().removeOverlayObject(this.overlay.id);
        }
        this.overlay = null;
        this.viewport = null;
    }

    getActors(): vtkActor[] {
        return [];
    }
}
